import { render, staticRenderFns } from "./user-types-register.page.vue?vue&type=template&id=4790e71f"
import script from "./user-types-register.page.vue?vue&type=script&lang=ts"
export * from "./user-types-register.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports